import { Project } from "interfaces";

import Tag from "ui-components/Tag";

import * as flowConfig from "flows/profile-discovery/config";
import { projectIsProfileDiscovery } from "flows/profile-discovery/interfaces";

const ContextSummary = ({ project }: { project: Project }) => {
  if (!projectIsProfileDiscovery(project)) {
    return null;
  }

  const wsId = project.workspaces[0]?.workspace;

  return (
    <div className="m-1">
      <p>
        ID Columns:{" "}
        <span className="underline">
          {project.meta_data[flowConfig.ID_COLUMNS_KEY].join(", ")}
        </span>
      </p>
      <p>
        Attributes:{" "}
        <span className="underline">
          {project.meta_data[flowConfig.ATTRIBUTE_COLUMNS_KEY].join(", ")}
        </span>
      </p>
      {wsId && (
        <div className="flex flex-wrap">
          <Tag bgColorClass="bg-primary-main" textColorClass="text-gray-100">
            Model Built
          </Tag>
        </div>
      )}
    </div>
  );
};

export default ContextSummary;
